var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',_vm._b({attrs:{"src":_vm.img,"alt":"AnyPay"}},'b-img',_vm.mainProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }